import React, { Fragment } from 'react'
import NProgress from 'react-nprogress'

import Icon from 'Pods/Shared/Icon/Icon'
import Tooltip from 'Pods/Shared/Tooltip'
import ListLoader from 'Pods/Shared/ListLoader'
import Loader from 'Pods/Shared/Loader'

import ProductAnalyticsSortableTh from './ProductAnalyticsSortableTh'
import myModelsTooltipContent from './Tooltips/myModelsTooltipContent'

export default class ProductAnalyticsMyProducts extends React.Component {
  constructor() {
    super()

    this.state = {
      products: {
        data: [],
        meta: {
          didFetch: false,
          sortBy: ['revenue', 'desc'],
        },
      },
      list: [],
      initialFetch: true,
      reloadFetch: false,
      searchTerm: '',
      axiosSource: axios.CancelToken.source(),
      isFittingContainer: false,
    }

    this.tableWrapper = React.createRef()
    this.stickyHeader = React.createRef()
    this.stickyBody = React.createRef()
    this.stickyColumn = React.createRef()
    this.actualTableBody = React.createRef()

    this.onFetchProductsSuccess = this.onFetchProductsSuccess.bind(this)
    this.handlePageChange = this.handlePageChange.bind(this)
    this.handleSortByChange = this.handleSortByChange.bind(this)
    this.handleInputChange = this.handleInputChange.bind(this)
    this.handleSearch = this.handleSearch.bind(this)
    this.renderTableBody = this.renderTableBody.bind(this)
    this.handleHeaderPosition = this.handleHeaderPosition.bind(this)
    this.handleResize = this.handleResize.bind(this)
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleResize)
    this.fetchProducts()
    this.handleResize()
  }

  componentWillUnmount() {
    this.state.axiosSource.cancel('Component Is Unmounting')
    window.removeEventListener('resize', this.handleResize)
  }

  handleHeaderPosition() {
    if (this.stickyHeader.current && this.stickyBody.current && this.stickyColumn.current) {
      this.stickyHeader.current.style.left = `${this.stickyBody.current.scrollLeft * -1}px`
      this.stickyColumn.current.style.top = `${this.stickyBody.current.scrollTop * -1}px`
    }
  }

  handleResize() {
    if ((this.tableWrapper.current) && (this.actualTableBody.current)) {
      if (this.tableWrapper.current.clientWidth < this.actualTableBody.current.clientWidth || this.state.products.meta.totalCount == 0) {
        this.setState({ isFittingContainer: false })
      } else {
        this.setState({ isFittingContainer: true })
      }
    }

    this.handleHeaderPosition()
  }

  fetchProducts(filterData = { page: 1, sort_by: ['revenue', 'desc'], term: [] }) {
    NProgress.start()

    return axios.get('/api/internal/product-analytics', {
      params: filterData,
      cancelToken: this.state.axiosSource.token,
    }).then(this.onFetchProductsSuccess)
      .catch((error) => {})
  }

  onFetchProductsSuccess(response) {
    NProgress.done()

    if (this.state.initialFetch && response.data.meta.totalCount !== 0) {
      this.setState({ initialFetch: false })
    }

    setTimeout(() => {
      this.handleResize()
    }, 20)

    return this.setState(prevState => ({
      products: response.data,
      list: this.state.reloadFetch ? response.data.data : prevState.list.concat(response.data.data),
    }))
  }

  handlePageChange(pageNumber) {
    this.setState({ reloadFetch: false })
    return this.fetchProducts({ page: pageNumber, sort_by: this.state.products.meta.sortBy, term: [this.state.searchTerm] })
  }

  handleSortByChange(attribute, direction) {
    this.setState({ reloadFetch: true })
    this.fetchProducts({ page: 1, sort_by: [attribute, direction], term: [this.state.searchTerm] })
  }

  handleInputChange(event) {
    this.setState({
      searchTerm: event.target.value,
    })
  }

  handleSearch(event) {
    event.preventDefault()
    this.setState({ reloadFetch: true })
    return this.fetchProducts({ page: 1, sort_by: this.state.products.meta.sortBy, term: [this.state.searchTerm] })
  }

  sortableThDirection(attribute) {
    return this.state.products.meta.sortBy[0] == attribute && this.state.products.meta.sortBy[1]
  }

  renderTableBody() {
    return (
      <Fragment>
        {this.state.products.meta.totalCount == 0 ? (
          <tbody>
            <tr className="table-row--5x">
              <td colSpan="8">
                <div className="empty-content-small u-text-center">
                  <p>
                    Sorry, no models found.
                  </p>
                </div>
              </td>
            </tr>
          </tbody>
        ) : (
          <tbody>
            {this.state.list.map((product, index) => (
              <tr key={product.id} className="table-row--1x">
                <td className="model-title">
                  <a href={product.attributes.url} target="_blank">
                    <div className="responsive-table__content">
                      {product.attributes.title}
                    </div>
                  </a>
                </td>
                <td className="u-text-center">{numeral(product.attributes.price).format('$0.00')}</td>
                <td className="u-text-center">{product.attributes.age}</td>
                <td className="u-text-center">{product.attributes.views}</td>
                <td className="u-text-center">{product.attributes.likes}</td>
                <td className="u-text-center">{product.attributes.sales}</td>
                <td className="u-text-center">{numeral(product.attributes.conversion).format('0%')}</td>
                <td className="u-text-center">{numeral(product.attributes.revenue).format('$0')}</td>
              </tr>
            ))}
          </tbody>
        )}
      </Fragment>
    )
  }

  renderLoader() {
    return (
      <div className="card card--flat">
        <Loader />
      </div>
    )
  }

  renderEmptyTable() {
    return (
      <div className="card card--flat">
        <div className="empty-content u-text-center">
          <p>
            Sorry, you haven't published any models yet!
          </p>
        </div>
      </div>
    )
  }

  render() {
    if (this.state.products.meta.didFetch == false) {
      return (
        this.renderLoader()
      )
    } if (this.state.initialFetch) {
      return (
        this.renderEmptyTable()
      )
    }
    return (
      <div className="card card--flat">
        <div className="l-inner">
          <h2 className="content-heading__h2">
            Personal Model Statistics
            <Tooltip
              tooltipClassName="tooltip--big tooltip--spaced"
              id="top-keywords--tooltip"
              html
              content={myModelsTooltipContent}
            >
              <Icon type={['fal', 'question-circle']} color="grey" className="info-icon" notSpaced />
            </Tooltip>
          </h2>
          <div ref={this.tableWrapper} className="table-responsive__wrapper">
            <div className="table-responsive table-responsive--default table-responsive--sticky-top analytics-table analytics-table--my-products">
              <table ref={this.stickyHeader} className={`analytics-table table-responsive__sticky-header ${!this.state.isFittingContainer ? '' : 'analytics-table__header-fits'}`}>
                <thead>
                  <tr className="table-row--3x">
                      <th className="u-text-left">
                        <div className="search-bar">
                          <span className="search-bar__title">Name</span>
                          <div className="search-bar__form-wrap">
                            <form className="search-bar__form" onSubmit={this.handleSearch}>
                              <input type="text" placeholder="Search by name" value={this.state.searchTerm} className="form-control form-control-sm" onChange={this.handleInputChange} />
                              <button type="submit" className="btn btn-transparent btn-sm">
                                <Icon type="search" color="green-dark" className="info-icon" notSpaced />
                              </button>
                            </form>
                          </div>
                        </div>
                      </th>

                      <ProductAnalyticsSortableTh
                        className="u-text-center"
                        attribute="price"
                        direction={this.sortableThDirection('price')}
                        onSortByChange={this.handleSortByChange}
                      >
                        Price
                      </ProductAnalyticsSortableTh>

                      <ProductAnalyticsSortableTh
                        className="u-text-center"
                        attribute="age"
                        direction={this.sortableThDirection('age')}
                        onSortByChange={this.handleSortByChange}
                      >
                        Age (days)
                      </ProductAnalyticsSortableTh>

                      <ProductAnalyticsSortableTh
                        className="u-text-center"
                        attribute="views"
                        direction={this.sortableThDirection('views')}
                        onSortByChange={this.handleSortByChange}
                      >
                        Views
                      </ProductAnalyticsSortableTh>

                      <ProductAnalyticsSortableTh
                        className="u-text-center"
                        attribute="likes"
                        direction={this.sortableThDirection('likes')}
                        onSortByChange={this.handleSortByChange}
                      >
                        Likes
                      </ProductAnalyticsSortableTh>

                      <ProductAnalyticsSortableTh
                        className="u-text-center"
                        attribute="sales"
                        direction={this.sortableThDirection('sales')}
                        onSortByChange={this.handleSortByChange}
                      >
                        Sales
                      </ProductAnalyticsSortableTh>

                      <ProductAnalyticsSortableTh
                        className="u-text-center"
                        attribute="conversion"
                        direction={this.sortableThDirection('conversion')}
                        onSortByChange={this.handleSortByChange}
                      >
                        Conversion
                      </ProductAnalyticsSortableTh>

                      <ProductAnalyticsSortableTh
                        className="u-text-center"
                        attribute="revenue"
                        direction={this.sortableThDirection('revenue')}
                        onSortByChange={this.handleSortByChange}
                      >
                        Revenue
                      </ProductAnalyticsSortableTh>
                    </tr>
                </thead>
              </table>
              <div className={`table-responsive__table-body ${!this.state.isFittingContainer && this.state.products.meta.totalCount > 0 ? 'table-responsive--sticky-left' : ''}`} ref={this.stickyBody} onScroll={this.handleHeaderPosition}>
                {!this.state.isFittingContainer && this.state.products.meta.totalCount > 0 && (
                <div className="analytics-table-wrapper">
                      <div className="table-responsive--sticky-left table-responsive__clone" ref={this.stickyColumn}>
                        <table className="analytics-table analytics-table--my-products">
                          {this.renderTableBody()}
                        </table>
                      </div>
                    </div>
                )}
                <table ref={this.actualTableBody} className="analytics-table analytics-table--my-products">
                  {this.renderTableBody()}
                </table>
              </div>
            </div>
          </div>
          <ListLoader
            totalPages={this.state.products.meta.totalPages}
            currentPage={this.state.products.meta.currentPage}
            onShowMore={this.handlePageChange}
            buttonClass="btn btn-transparent btn-block btn-show-more__small-margins"
          />
        </div>
      </div>
    )
  }
}
